import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { RegUser } from '../../basic-reg/RegUser';
import { AlertController } from '@ionic/angular';
import { CommonUtil } from 'src/app/util/CommonUtil';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MathcesCategoryPipe } from 'src/app/pipe/matchesCategory.pipe';
import { ContactCategory } from 'src/app/constants/ContactCategory';
import { finalize, filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-directory-dashbord-new',
  templateUrl: './directory-dashbord-new.component.html',
  styleUrls: ['./directory-dashbord-new.component.scss', '../../../../assets/css/style.scss'],
  providers: [MathcesCategoryPipe],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    MathcesCategoryPipe
  ]
})
export class DirectoryDashbordNewComponent implements OnInit, OnDestroy {
  getMaskedEmail(email: string): string {
    return CommonUtil.getMaskedEmail(email);
  }

  getMaskedPhone(phone: string): string {
    return CommonUtil.getMaskedPhone(phone);
  }

  // Placeholder method to resolve build error
  searchContacts(pageNo: number): void {
    // TODO: Implement actual search logic or call the correct method
    this.userContacts = [];
  }

  errorMessage: string = '';
  requestPath: string = '';
  lastLoadedPage: number = 1;
  user: RegUser = new RegUser();
  ownerId: number = 0;
  profileImageSrc: any = '';
  contactIds: number[] = [];
  noDataFound = true;
  loadingData = false;

  userContacts: any[] = [];
  requestedContacts: any[] = [];
  pendingRequests: any[] = [];

  p: number = 1;

  // Contact Category
  all: string = ContactCategory.ALL;
  friends: string = ContactCategory.FRIENDS;
  work: string = ContactCategory.WORK;
  family: string = ContactCategory.FAMILY;
  others: string = ContactCategory.OTHERS;
  favorite: string = ContactCategory.FAVOURITE;

  selectedCategory: string = this.all;
  private navigationSubscription?: Subscription;
  private isInitialLoad: boolean = true;

  constructor(public global: Globals,
    public authService: AuthServiceService,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    public router: Router,
    private loader: LoaderService,
    public atrCtrl: AlertController,
    private modalService: NgbModal,
    private matchesCategory: MathcesCategoryPipe,
    private cdr: ChangeDetectorRef) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit() {
    this.initializeDirectoryPage();
    
    // Subscribe to navigation events to reload data when navigating to this page
    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url.includes('directory-dashbord-new')) {
          // Skip the initial load to prevent duplicate API calls
          if (this.isInitialLoad) {
            this.isInitialLoad = false;
            return;
          }
          this.initializeDirectoryPage();
        }
      });
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private initializeDirectoryPage() {
    this.resetInputs();
    const loggedInUser = this.authService.getLoggedInUser();

    this.user = loggedInUser ?? new RegUser();
    this.ownerId = loggedInUser?.id ?? 0;
    this.profileImageSrc = this.authService.getProfilePicture() as string;

    if (this.global.isEmpty(loggedInUser)) {
      this.getMyProfile(() => {
        this.getUserContacts();
      });
    } else {
      this.user.imageUrl = this.profileImageSrc;
      this.getUserContacts();
    }
  }

  getMyProfile = (onSuccess?: () => void) => {
    this.authService.get('user?' + this.requestPath + '=getUserDetail')
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Update user data
          this.user = this.global.decrypt(res.data);;
          this.user.imageUrl = this.profileImageSrc;
          this.ownerId = this.user.id ?? 0;

          // Save data in local storage
          this.global.saveLocalData(this.global.HIDDIN_USER_DETAILS, JSON.stringify(this.user));
          if (onSuccess) {
            onSuccess();
          }
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
  }

  getUserContacts = () => {
    this.loadingData = true;
    this.userContacts = [];
    this.cdr.detectChanges(); // Force update to show loader
    
    try {
      const request = this.authService.get('user/directory?' + this.requestPath + '=list');
      if (!request) {
        this.loadingData = false;
        this.noDataFound = true;
        this.errorMessage = 'Unable to load contacts. Please try again.';
        this.cdr.detectChanges();
        return;
      }

      request.pipe(finalize(() => {
        this.loadingData = false;
        this.cdr.detectChanges(); // Force update when loading completes
      }))
      .subscribe((res: any) => {
        if (res.success) {
          this.userContacts = this.global.decrypt(res.data) || [];
          if (this.userContacts != null && this.userContacts.length > 0) {
            this.noDataFound = false;
            this.contactIds = this.userContacts.map((contact: any) => { return contact.contactUser.id; });
            this.contactIds.push(this.ownerId);
            for (var contact of this.userContacts) {
              if (contact.ownerId == this.ownerId) {
                contact.category = contact.senderCategory;
              } else {
                contact.category = contact.recieverCategory;
              }
            }
          } else {
            this.noDataFound = true;
          }
        } else {
          this.errorMessage = res.message;
          this.noDataFound = true;
        }
        this.cdr.detectChanges(); // Force update with data
      }, (error: any) => {
        this.errorMessage = "Something went wrong, please try again.";
        this.noDataFound = true;
        this.cdr.detectChanges();
      });
    } catch (error) {
      this.loadingData = false;
      this.noDataFound = true;
      this.errorMessage = "Something went wrong, please try again.";
      this.cdr.detectChanges();
    }
  }

  markFavorite(userContact: any, isFavorite: boolean) {
    userContact.isFavorite = isFavorite;
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=save', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Reinitialized the form state
          this.getUserContacts();
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
  }

  pendingTab() {
    this.router.navigateByUrl('/pending-request-new');
    return false;

  }
  open(content: any) {
    this.modalService.open(content);
  }

  close(content: any) {
    this.modalService.dismissAll(content);
  }

  resetInputs() {
    this.errorMessage = '';
  }

  goTo(link: string) {
    this.router.navigateByUrl(link)
  }

  convertTime(time: any) {
    if (!time) {
      return '';
    }
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  pagechange = (event: any) => {
    // console.log(event);
    this.p = event;
    if ((event >= ((5 * this.lastLoadedPage) - 1))) {
      this.searchContacts(this.lastLoadedPage + 1);
    }
  }

  changeTab(tabName: any) {
    this.selectedCategory = tabName;
    var filterData = null;
    if (tabName == this.all) {
      filterData = this.userContacts;
    } else {
      if (tabName == this.favorite) {
        filterData = this.userContacts.filter((contact: any) => { return contact.isFavorite === true; });
      } else {
        filterData = this.userContacts.filter((contact: any) => { return contact.category === tabName; });
      }
    }
    if (filterData != null && filterData.length > 0) {
      this.noDataFound = false;
    } else if (filterData.length == 0) {
      this.noDataFound = true;
    }
  }

  goToSearch() {
    this.router.navigate(["search-new"]);
  }

  openProfile(userContact: any, user: any, editEnabled: boolean, isSearchResult: boolean) {
    this.router.navigateByUrl('/profile-details-new', { state: { 'userContact': userContact, 'user': user, 'editEnabled': editEnabled, 'addEnabled': !this.contactIds.includes(user.id), 'isSearchResult': isSearchResult, 'viewTimeSlot': true } });
    return false;
  }

}
